import {map, pipe, uniqBy} from 'ramda';

import {GetSignableDocumentListResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

export const getUniqueSignatories = (documents: GetSignableDocumentListResponseBody[] | Nullish) =>
  pipe(
    map((document: GetSignableDocumentListResponseBody) => document.metadata),
    (metadata) => metadata.flat(),
    uniqBy((signatory) => signatory.signatoryPerson)
  )(documents ?? []);
